import React, { useMemo } from 'react';

import { formatPurchaseOrderDate } from 'components/procurement/components/purchaseOrdersV2/utils/purchaseOrderDateUtils';
import { normalizeOptionalText } from 'components/procurement/components/purchaseOrdersV2/utils/purchaseOrderDisplayUtils';
import {
    FC_TRANSFER_DISPLAY_FALLBACK,
    getTransferStatusDisplay,
} from 'components/warehouse/components/fcTransfers/fcTransferDisplayUtils';

const labelClassName = 'text-left text-xs font-semibold uppercase leading-tight tracking-wide text-muted-foreground';
const valueClassName = 'text-left text-sm font-medium text-foreground';

/**
 * Primary transfer information
 *
 * @param {Object} props
 * @param {Record<string, unknown> | null} [props.transfer]
 */
export function FCTransferInfoCard({ transfer = null }) {
    const sections = useMemo(() => {
        const createdRaw = transfer?.createdAt ?? transfer?.created_at;
        const createdDisplay = formatPurchaseOrderDate(createdRaw, FC_TRANSFER_DISPLAY_FALLBACK);
        return [
            {
                label: 'Source FC',
                value: normalizeOptionalText(transfer?.sourceFacilityName ?? transfer?.source_facility_name),
            },
            {
                label: 'Destination FC',
                value: normalizeOptionalText(transfer?.destinationFacilityName ?? transfer?.destination_facility_name),
            },
            { label: 'Status', value: normalizeOptionalText(getTransferStatusDisplay(transfer)) },
            { label: 'Created On', value: createdDisplay },
            { label: 'Created By', value: normalizeOptionalText(transfer?.createdBy ?? transfer?.created_by) },
            {
                label: 'Notes',
                value: normalizeOptionalText(transfer?.notes),
            },
        ];
    }, [transfer]);

    return (
        <div className="rounded-md border bg-card p-6 shadow-sm">
            <div className="flex flex-col gap-4">
                <h2 className="text-left text-lg font-semibold tracking-tight text-foreground">Transfer information</h2>
                <dl className="grid gap-4 sm:grid-cols-2">
                    {sections.map(({ label, value }) => (
                        <div key={label} className="flex min-w-0 flex-col gap-1">
                            <dt className={labelClassName}>{label}</dt>
                            <dd className={`${valueClassName} break-words`}>{value}</dd>
                        </div>
                    ))}
                </dl>
            </div>
        </div>
    );
}

FCTransferInfoCard.displayName = 'FCTransferInfoCard';
